import { ClientCreditCardLists, ClientCreditCardsRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useFetchClientCreditCards() {
  const api = useApi();
  // One value instead of a boolean, matching useFetchBankAccounts: the listing has to tell "never
  // fetched" from "the last fetch failed" to choose between a skeleton, an empty state and an error,
  // and a single `fetching` flag reads false for both. A failure leaves the previous cards in place.
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [creditCards, setCreditCards] = useState<ClientCreditCardLists[]>([]);

  // PortalUser omitted: no earthnode handler for this endpoint reads it (verified against
  // lib/www/routes/v2/credit_card.php) — the backend takes the user from the JWT.
  async function fetchCreditCards(params: Omit<ClientCreditCardsRequest, 'PortalUser'>) {
    try {
      setStatus('loading');
      const res = await api.fetchClientCreditCards(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setCreditCards(res.CreditCards);
      setStatus('success');

      return res;
    } catch (error) {
      setStatus('error');
      console.error(error);
      throw error;
    }
  }

  return { status, creditCards, fetchCreditCards };
}
